import qs from 'qs';
import { serialize } from 'object-to-formdata';
import { groupsAdapter } from '@/adapters/vacancies';
import { vacanciesAdapter, vacancyAdapter } from '@/adapters/vacancies';

export const useVacanciesStore = defineStore({
  id: 'vacancies',
  state: () => ({
    groups: null,
  }),
  getters: {
    getGroupById: (state) => (groupId) =>
      state.groups?.find(({ id }) => id === groupId),
  },
  actions: {
    fetchGroups() {
      return useRequest('/vacancies/groups').then(({ data }) => {
        this.groups = groupsAdapter(data);

        return this.groups;
      });
    },
    fetchVacancies({ filter: { groupId }, limit, offset }) {
      const query = qs.stringify(
        { filter: { group_id: groupId }, limit, offset },
        { skipNulls: true, addQueryPrefix: true },
      );

      return useRequest(`/vacancies${query}`).then(vacanciesAdapter);
    },
    fetchVacancy(vacancyId) {
      return useRequest(`/vacancies/${vacancyId}`).then(({ data }) =>
        vacancyAdapter(data),
      );
    },
    register(fields) {
      return useRequest('/vacancies', {
        method: 'post',
        body: serialize({
          vacancy_id: fields.vacancyId,
          name: fields.name,
          city: fields.city,
          phone: fields.phone,
          email: fields.email,
          message: fields.message,
          attachment: fields.attachment,
          'y-smartcaptcha': fields.captcha,
        }),
      }).catch((error) => {
        const {
          data: { errors },
        } = error;

        if (!errors) throw error;

        throw {
          errors: {
            vacancyId: errors.vacancy_id,
            name: errors.name,
            city: errors.city,
            phone: errors.phone,
            email: errors.email,
            message: errors.message,
            attachment: errors.attachment,
            captcha: errors['y-smartcaptcha'],
          },
        };
      });
    },
  },
});
